/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  fill1?: string;
  fill2?: string;
  fill3?: string;
}
const TradeHistory = (props: IconProps) => {
  const {
    fill1 = 'var(--secondaryText)',
    fill2 = 'var(--brand-bg-primary)',
    fill3 = 'var(--secondaryText)',
    ...restProps
  } = props;
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
      {...restProps}
      data-palette="TradeHistory">
      <path
        fill={fill1}
        d="M5.163.19C6.575 0 8.384 0 10.693 0h.114c2.309 0 4.118 0 5.529.19 1.445.194 2.585.599 3.48 1.494.894.895 1.3 2.035 1.494 3.479.19 1.412.19 3.221.19 5.53v.114L20 10.75c0-2.378-.002-4.086-.176-5.386-.172-1.279-.499-2.049-1.068-2.619-.57-.569-1.341-.897-2.62-1.069-1.3-.174-3.008-.176-5.386-.176s-4.086.002-5.386.176c-1.279.172-2.049.499-2.619 1.069-.569.57-.897 1.34-1.069 2.619-.174 1.3-.176 3.008-.176 5.386s.002 4.086.176 5.386c.172 1.279.499 2.049 1.068 2.619.57.569 1.341.897 2.62 1.069 1.3.174 3.008.176 5.386.176l.057 1.5h-.114c-2.309 0-4.118 0-5.529-.19-1.445-.194-2.585-.599-3.48-1.494-.894-.895-1.3-2.035-1.494-3.479C0 14.925 0 13.116 0 10.807v-.114c0-2.309 0-4.118.19-5.529.194-1.445.599-2.585 1.494-3.48C2.579.79 3.719.384 5.163.19Z"
      />
      <path
        fill={fill2}
        d="M18.583 12.75a5.25 5.25 0 0 0-5.25 5.25h-1.75l2.27 2.27.04.08L16.25 18H14.5a4.08 4.08 0 0 1 4.083-4.083A4.08 4.08 0 0 1 22.667 18a4.08 4.08 0 0 1-4.084 4.083 4.05 4.05 0 0 1-2.881-1.201l-.829.828a5.223 5.223 0 0 0 3.71 1.54 5.25 5.25 0 1 0 0-10.5ZM18 15.667v2.916l2.497 1.482.42-.706-2.042-1.213v-2.48H18Z"
      />
      <path
        fill={fill3}
        d="M12.5 7.75c0 .414.336.75.75.75h.69l-2.013 2.013a.25.25 0 0 1-.354 0L9.987 8.927a1.75 1.75 0 0 0-2.474 0L5.22 11.22a.75.75 0 1 0 1.06 1.06l2.293-2.293a.25.25 0 0 1 .354 0l1.586 1.586a1.75 1.75 0 0 0 2.474 0L15 9.561v.689a.75.75 0 1 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75Z"
      />
    </svg>)
  );
};
export default TradeHistory;
